import userReducer from '../features/users/userSlice';
import assessmentCyclesReducer from '../features/assessmentCycles/assessmentCyclesSlice';
import questionBanksReducer from '../features/questionBanks/questionBanksSlice';
import analyticsReportsReducer from '../features/analyticsReports/analyticsReportsSlice';
import externalCandidateReportsReducer from '../features/Reports/externalCandidateReportSlice';
import technicalAssessmentsReducer from './technicalAssessments/technicalAssessmentsSlice';
import userListReducer from '../features/userAnalysis/userAnalysisSlice';
import selfAssessmentReportsReducer from '../features/Reports/selfAssessmentReportSlice';
import cycleReportReducer from '../features/Reports/cycleReportSlice';
import assessmentReportReducer from '../features/Reports/assessmentReportSlice';
import manageEmployeesReducer from '../features/ManageEmployees/manageEmployeesSlice';
import manageAssessorReducer from '../features/ManageAssessor/ManageAssessorSlice';
import manageSkilsReducer from '../features/ManageSkills/ManageSkillsSlice';
import manageExternaluserReducer from '../features/ManageExternalUsers/ManageExternalUsersSlice';
import manageEmployeeCycleReducer from '../features/ManageEmployeeCycle/ManageEmployeeCycleSlice';
import internalUserReducer from '../features/internalusers/internaluserSlice';
import externalUserReducer from '../features/externalusers/externaluserSlice';
import approveReviewModificationsReducer from '../features/approveReviewModifications/approveReviewModificationsSlice';
import questionBankReviewReducer from '../features/questionBankReview/questionBankReviewSlice';
import technicalQuestionBankReducer from '../features/technicalQuestionBank/technicalQuestionBankSlice';
import manageSMEReducer from '../features/manageSME/manageSMESlice';
import employeesReducer from '../features/Employees/GetAllEmployeesSlice';
import getCurrentDetailsReducer from './GetCycleCurrentDetails/GetCycleCurrentDetailsSlice';
import cycleChangesReducer from './SaveCycleChanges/SaveCycleChangesSlice';
import emailTypesReducer from './EmailTypes/EmailTypesSlice';
import selfAssessmentReducer from './SelfAssessmentScreen/SelfAssessmentScreenSlice'
import userNotificationReducer from '../features/Notification/notificationSlice';
import sendWelcomeEmailReducer from './SendWelcomeEmail/SendWelcomeEmailSlice';

const rootReducers = {
  users: userReducer,
  userList: userListReducer,
  assessmentCycles: assessmentCyclesReducer,
  questionBanks: questionBanksReducer,
  analyticsReports: analyticsReportsReducer,
  externalCandidate: externalCandidateReportsReducer,
  technicalAssessments: technicalAssessmentsReducer,
  selfAssessmentReport: selfAssessmentReportsReducer,
  cycleReport: cycleReportReducer,
  assessmentReport: assessmentReportReducer,
  manageEmployeeCycles: manageEmployeesReducer,
  manageAssessorCycles: manageAssessorReducer,
  manageSkillCycles: manageSkilsReducer,
  manageExternaluserCycle: manageExternaluserReducer,
  manageEmployeeCycle: manageEmployeeCycleReducer,
  externalUser: externalUserReducer,
  internalUser: internalUserReducer,
  approveReviewModifications: approveReviewModificationsReducer,
  questionBankReview: questionBankReviewReducer,
  technicalQuestionBank: technicalQuestionBankReducer,
  manageSME: manageSMEReducer,
  employeesData: employeesReducer,
  cycleDetails: getCurrentDetailsReducer,
  cycleChanges: cycleChangesReducer,
  emailTypes: emailTypesReducer,
  selfAssessment: selfAssessmentReducer,
  userNotifications: userNotificationReducer,
  sendWelcomeEmail: sendWelcomeEmailReducer,
};

export default rootReducers;
